import axios from 'axios';

import SERVER from 'lib/networking/endpoints';

const client = axios.create({ withCredentials: true, baseURL: SERVER });

const httpGet = (URL, headers = {}) => {
  return client.get(URL, { headers });
};

const httpPost = (URL, data, headers = {}) => {
  return client.post(URL, data, { headers });
};

const httpPut = (URL, data, headers = {}) => {
  return client.put(URL, data, { headers });
};

const httpDelete = (URL, headers = {}) => {
  return client.delete(URL, { headers });
};

const httpPatch = (URL, data, headers = {}) => {
  return client.patch(URL, data, { headers });
};

// Fetch a file as a blob over the credentialed client and trigger a browser download,
// using the server's Content-Disposition filename when present (fallbackName otherwise).
const downloadFile = (URL, fallbackName = 'export') =>
  client.get(URL, { responseType: 'blob' }).then(response => {
    const disposition = response.headers['content-disposition'] || '';
    const match = disposition.match(/filename="?([^"]+)"?/);
    const filename = match ? match[1] : fallbackName;
    const blobUrl = window.URL.createObjectURL(response.data);
    const anchor = document.createElement('a');
    anchor.href = blobUrl;
    anchor.download = filename;
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    window.URL.revokeObjectURL(blobUrl);
  });

export { client, httpGet, httpPost, httpPut, httpDelete, httpPatch, downloadFile };
